import type { Room } from '../../rooms.js';
import { IconCommunity, IconFamily, IconHousehold, IconMe } from '../Icons.js';

export function RoomIcon({ room }: { room: Room }): React.JSX.Element {
  if (room === 'household') return <IconHousehold />;
  if (room === 'family') return <IconFamily />;
  if (room === 'community') return <IconCommunity />;
  return <IconMe />;
}
